import {
    axiosPost, axiosGet,axiosPostAuthorize, // TO DO unused import // TO DO lazy load component
    axiosGetAuthorize} from '../AxiosRequests';
import {GetEmailConfigurationsList, UpdateEmailConfigurations, DeleteEmailConfigurations, GetEmailConfigurationsById,AddEmailConfigurations } from '../ApiEndPoints';

export default class EmailConfigurationServices {

    async addEmailConfigurations(request) {
        return axiosPostAuthorize(AddEmailConfigurations, request);
    }

    async updateEmailConfigurations(request) {
        return axiosPostAuthorize(UpdateEmailConfigurations, request);
    }

    async deleteEmailConfigurations(request) {
        return axiosPostAuthorize(DeleteEmailConfigurations, request);
    }

    async getEmailConfigurationsById(request) {
        return axiosGetAuthorize(GetEmailConfigurationsById, request);
    }
    
    async getEmailConfigurationsList(request){
        return axiosPostAuthorize(GetEmailConfigurationsList, request);
    }

       
}